// Tiny segmented tab switcher. Pairs each `tab` button (data-tab="X") with
// its `pane` (data-tab="X") sibling: clicking a tab shows its pane and
// hides the others. Visual active-state is driven by toggling the active
// gradient classes vs. the muted classes.
import { Controller } from "@hotwired/stimulus"

const ACTIVE_CLASSES = [
  "text-white",
  "bg-gradient-to-b",
  "from-[var(--color-brand-500)]",
  "to-[var(--color-brand-600)]",
  "shadow-[0_3px_8px_rgba(249,115,22,0.3),inset_0_1px_0_rgba(255,255,255,0.18)]",
]
const INACTIVE_CLASSES = ["text-[var(--color-ink-muted)]", "hover:text-[var(--color-ink)]"]

export default class extends Controller<HTMLElement> {
  static targets = ["tab", "pane"]
  declare readonly tabTargets: HTMLElement[]
  declare readonly paneTargets: HTMLElement[]

  show(event: Event): void {
    const button = event.currentTarget as HTMLElement
    const wanted = button.dataset.tab
    if (!wanted) return
    this.tabTargets.forEach(t => this.setActive(t, t.dataset.tab === wanted))
    this.paneTargets.forEach(p => p.classList.toggle("hidden", p.dataset.tab !== wanted))
  }

  private setActive(tab: HTMLElement, active: boolean): void {
    if (active) {
      tab.classList.remove(...INACTIVE_CLASSES)
      tab.classList.add(...ACTIVE_CLASSES)
    } else {
      tab.classList.remove(...ACTIVE_CLASSES)
      tab.classList.add(...INACTIVE_CLASSES)
    }
  }
}
